// Small helpers for reading Axios-shaped errors without importing Axios types
// into composables (keeps them easy to test with plain rejected objects).

interface ErrorResponseShape {
  status?: number
  data?: { errors?: Record<string, string[]>; message?: string }
}

function responseOf(e: unknown): ErrorResponseShape | null {
  if (typeof e === 'object' && e !== null && 'response' in e) {
    const response = (e as { response: unknown }).response
    if (typeof response === 'object' && response !== null) {
      return response as ErrorResponseShape
    }
  }
  return null
}

export function httpStatus(e: unknown): number | null {
  return responseOf(e)?.status ?? null
}

export function validationErrors(e: unknown): Record<string, string[]> | null {
  const response = responseOf(e)
  if (response?.status !== 422) return null
  return response.data?.errors ?? {}
}
